import * as actions from './roles.actions';
import { IRole } from '@roles/models/IRole';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { IUserRole, RoleType } from '@account-users/user/models/UserRole';

export const ROLES_FEATURE_KEY = 'roles';

export interface RolesState {
  rolesPermissions: IRole;
  isLoadingRoles: boolean;
  roles: IUserRole[];
  isLoadingUserRoles: boolean;
}

export const initialState: RolesState = {
  rolesPermissions: {},
  isLoadingRoles: false,
  roles: [],
  isLoadingUserRoles: false,
};

export function reducer(
  state: RolesState = initialState,
  action: actions.RolesActions,
): RolesState {
  switch (action.type) {
    case actions.RolesActionTypes.LOAD_ROLES: {
      return {
        ...state,
        rolesPermissions: {},
        roles: [],
        isLoadingRoles: true,
      };
    }

    case actions.RolesActionTypes.LOAD_ROLES_SUCCESS: {
      const { rolesPermissions, roles } = action.payload;
      return {
        ...state,
        rolesPermissions: rolesPermissions,
        roles: roles,
        isLoadingRoles: false,
      };
    }

    case actions.RolesActionTypes.LOAD_ROLES_FAILED: {
      return {
        ...state,
        rolesPermissions: {},
        roles: [],
        isLoadingRoles: false,
      };
    }
  }
}

export const getRolesState = createFeatureSelector<RolesState>(
  ROLES_FEATURE_KEY,
);

export const getUserRolesArray = createSelector(
  getRolesState,
  ({ roles, rolesPermissions }) =>
    roles
      .filter((role) => role.type === RoleType.User)
      .map((r) => r.code)
      .sort((a, b) => rolesPermissions[a].length - rolesPermissions[b].length),
);

export const getAccountUserRolesArray = createSelector(
  getRolesState,
  ({ roles, rolesPermissions }) =>
    roles
      .filter((role) => role.type === RoleType.AccountUser)
      .map((r) => r.code)
      .sort((a, b) => rolesPermissions[a].length - rolesPermissions[b].length),
);

export const getRolesPermissions = createSelector(
  getRolesState,
  ({ rolesPermissions }) => rolesPermissions,
);

export const getIsLoadingRoles = createSelector(
  getRolesState,
  ({ isLoadingRoles }) => isLoadingRoles,
);

export const getAllBOPermissions = createSelector(
  getUserRolesArray,
  getRolesPermissions,
  (roles, permissions) => {
    let perm = [];
    roles.forEach((role) => {
      permissions[role].forEach((permission) => {
        perm = perm.indexOf(permission) < 0 ? [...perm, permission] : [...perm];
      });
    });
    return perm.sort((a, b) => a.localeCompare(b));
  },
);

export const getAllOnePermissions = createSelector(
  getAccountUserRolesArray,
  getRolesPermissions,
  (roles, permissions) => {
    let perm = [];
    roles.forEach((role) => {
      permissions[role].forEach((permission) => {
        perm = perm.indexOf(permission) < 0 ? [...perm, permission] : [...perm];
      });
    });
    return perm.sort((a, b) => a.localeCompare(b));
  },
);
